import smaController from './sma-controller';
import appVersionController from './app-version.controller';
import dataPoolController from './data-pool.controller';
import dataDictController from './data-dict.controller';
import uploadFileController from './upload-file.controller';
import reminderMessageController from "./reminder-message.controller";
export var commonService = {
    appVersionController: appVersionController,
    dataDictController: dataDictController,
    smaController: smaController,
    uploadFileController: uploadFileController,
    dataPoolController: dataPoolController,
    reminderMessageController: reminderMessageController
};
